/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-26 18:01:48
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-26 18:03:32
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/TextedSwitch/TextedSwitch.tsx
 */
/**
 *  Switch with text component
 *  Author: Chris Hao
 *  CreatedAt: 2021-03-23
 */

import Switch from '@/src/components/Antd/Switch/Switch';
import React, { useState } from 'react';

// import { EnumPromotionSwitch } from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/common';

import { replaceI18nVariables } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './TextedSwitch.less';

interface IProps {
  className?: string;
  title: string;
  defaultChecked: boolean;
  onChange: (v) => void;
  onClickJumpPage?: () => void;
}

const arrowImgUrl =
  'https://resource2.unifyxp.com/shopper-v2/pc/sales-channel-promotion-arrow.svg';

const TextedSwitch = ({
  className,
  title,
  defaultChecked,
  onChange,
  onClickJumpPage,
}: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [checked, setChecked] = useState(defaultChecked);

  const handleChange = (checked) => {
    setChecked(checked);
    if (onChange) {
      onChange(checked);
    }
  };

  return (
    <div className={`${css.container} ${className}`}>
      <div className={css.head}>
        <div className={css.title}>{title}</div>
        <div className={css.switch}>
          <Switch onChange={handleChange} defaultChecked={defaultChecked} />
        </div>
      </div>
      {checked && (
        <div className={css.body} onClick={onClickJumpPage}>
          <img className={css.arrow} src={arrowImgUrl} alt='arrow' />
          <span className={css.extraText}>
            {replaceI18nVariables(
              getI18n('salesChannelContent.index.viewintitle'),
              title,
            )}
          </span>
        </div>
      )}
    </div>
  );
};

export default TextedSwitch;
